import * as React from 'react';
import { Component, CSSProperties, ReactNode } from 'react';
import * as classNames from 'classnames';
import * as _ from 'lodash';

if (process.env.BROWSER) {
  require('./index.less');
}

import {
  INewsItem,
  INewsItemThumbnail,
} from '../model';
import {
  NewsStyleType,
  INewsConfig,
} from '../model/config';

import {
  getDomNewsMeta,
} from '../util/dom';

interface IComponentProps {
  className?: string;
  style?: CSSProperties;
  isRTL: boolean;
  news: INewsItem;
  onClick?: () => void;
}
interface IComponentState {}

export default class ItemCovers extends Component<IComponentProps, IComponentState> {
  constructor(props) {
    super(props);
    this.state = {};
    [
      'handleOnClick',
      'getDomTitle',
      'getDomListThumnail',
      'getDomMeta',
    ].forEach((actionName: string) => {
      this[actionName] = this[actionName].bind(this);
    });
  }

  public render(): ReactNode {
    const classesRoot: string = classNames('news-item', 'news-item-covers', this.props.className);
    const domTitle: ReactNode = this.getDomTitle();
    const domThumnail: ReactNode = this.getDomListThumnail();
    const domMeta: ReactNode = this.getDomMeta();
    return (
      <a className={classesRoot} style={this.props.style}
         onClick={(e) => this.handleOnClick(e)}
         href="#"
      >
        { domTitle }
        { domThumnail }
        { domMeta }
      </a>
    );
  }

  public handleOnClick(e): boolean {
    e.preventDefault();
    const news: INewsItem = this.props.news;
    if (this.props.onClick) {
      this.props.onClick();
    }
    return false;
  }

  public getDomTitle(): ReactNode {
    const news: INewsItem = this.props.news;
    const classesTitle: string = classNames('news-item-title', 'news-item-covers-title', {
      'news-item-title-rtl': this.props.isRTL,
    });
    const domTitle: ReactNode = (
      <div className={ classesTitle }>{ news.title }</div>
    );
    return domTitle;
  }

  public getDomListThumnail(): ReactNode {
    const news: INewsItem = this.props.news;
    let domImgContainer: ReactNode = null;
    if (news.thumbnails === undefined || news.thumbnails === null || news.thumbnails.length === 0) {
      return domImgContainer;
    }
    const picList: INewsItemThumbnail[] = _.filter(news.thumbnails, (thumbnailItem, index: number) => {
      return index <= 2;
    });
    domImgContainer = (
      <div className={'news-item-covers-imgList'}>
        {picList.map((thumbnailItem: INewsItemThumbnail) => {
          return (
            <div key={ thumbnailItem.id } className={'news-item-covers-imgContainer'}>
              <img src={ thumbnailItem.url }/>
            </div>
          );
        })}
      </div>
    );
    return domImgContainer;
  }

  public getDomMeta(): ReactNode {
    const news: INewsItem = this.props.news;
    const classesMeta: string = classNames('news-item-meta', 'news-item-covers-meta', {
      'news-item-meta-rtl': this.props.isRTL,
    });
    const domMetaFragment: ReactNode = getDomNewsMeta(news);
    const domMeta: ReactNode = (
      <div className={ classesMeta }>{ domMetaFragment }</div>
    );
    return domMeta;
  }

}
